// Autogenerated file
export const accountsReceivableReportSourcesEnum = {
    OwnFleet: "OwnFleet",
    HiredCar: "HiredCar",
    All: "All",
};
export const accountsReceivableReportSources = [
    { label: "Заявки собственного парка", value: "OwnFleet" },
    { label: "Заказы с наёмным ТС", value: "HiredCar" },
    { label: "Все", value: "All" },
];
